import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {playCorrect,playWrong} from './PlaySounds';
import TopBar from './GameTopBar';
import {setGameScreenNumber,setCurrentQuestion,showCorrectWrongImage,setScore} from '../actions/commonActions';
var userAnser;
var intervalId;
class GameQuestionScreen extends Component {

  UNSAFE_componentWillMount(){
    clearInterval(intervalId);
}
  showAnswerScreen = (userAns) => {
    this.props.showCorrectWrongImage(true);
    userAnser = userAns;
    if(userAns === this.props.currentQuestion.notAMyth){
        this.props.setScore(this.props.score +1);
        playCorrect();
    }else{
        playWrong();
    }
    intervalId = setInterval(() => this.updateShowImage(), 2000);
      
      
  };

    updateShowImage(){
      clearInterval(intervalId);
      this.props.showCorrectWrongImage(false);
      this.props.setGameScreenNumber(2,2);
    }
    

    render() {

      if(this.props.mythsAndFacts.length > 0){
        this.props.setCurrentQuestion(this.props.mythsAndFacts[this.props.currentIndex])
      }



      var direction = "";
      var question = this.props.currentQuestion.statement;
      var mythBtnText = this.props.currentQuestion.mythBtnText;
      var factBtnText = this.props.currentQuestion.factBtnText;
      var correctWrongImageClass = "hidden";
      // var correctWrongImageClass = "correct_wrong_image";
      var correctWrongImageSrc = "virus_wrong.png";
      if(userAnser === this.props.currentQuestion.notAMyth){
        correctWrongImageSrc = "virus_correct.png"
    }
      if(this.props.showCorrectWrong){
        correctWrongImageClass = "correct_wrong_image";
      }
     
      if(this.props.language === "en"){
          //question = "question goes here yaha pe question hoga aure batao kia hall hain sab teek hain ";
           direction = "ltr";
      }else if(this.props.language === "ur"){
        //question = "question goes here yaha pe question hoga aure batao kia hall hain sab teek hain ";
          direction = "rtl";
      }
            return(
                <div className = "screen_background">
                    <img src={"/game-skins/build-rev88-FwtEb7liF/images_"+this.props.language+"/"+correctWrongImageSrc} alt="" className={correctWrongImageClass} />
                  <div>
                    <TopBar/>
                  </div>
                  <div dir={direction} className = "question_popup">
                    {question}<br/>
                  </div>
                  <div 
                  className="button_fact_myth" 
                  onClick = {()=>this.showAnswerScreen(true)}
                  style = {{
                backgroundImage: "url(game-skins/build-rev88-FwtEb7liF/images_en/btn_fact.png)"
              }}>
                   {factBtnText}
                  </div>
                  <div 
                   className="button_fact_myth" 
                   onClick = {()=>this.showAnswerScreen(false)}
                  style = {{
                backgroundImage: "url(/game-skins/build-rev88-FwtEb7liF/images_en/btn_myth.png)"
              }}>
                 {mythBtnText}
                  </div>
                </div>
            )
    }
}

GameQuestionScreen.propTypes = {
  language:PropTypes.string.isRequired,
  currentQuestion:PropTypes.object.isRequired,
  mythsAndFacts:PropTypes.array.isRequired,
  currentIndex:PropTypes.number.isRequired,
  score:PropTypes.number.isRequired,
  playTime:PropTypes.number.isRequired
}
const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  currentQuestion:state.config.currentQuestion,
  mythsAndFacts:state.localData.mythsAndFacts,
  currentIndex:state.config.currentIndex,
  score:state.config.score,
  playTime:state.config.playTime,
  showCorrectWrong:state.config.showCorrectWrong
});
export default withRouter(connect(mapStateToProps,{setGameScreenNumber,setCurrentQuestion,showCorrectWrongImage,setScore})(GameQuestionScreen));
//export default withRouter(IntroScreen);



// WEBPACK FOOTER //
// ./src/components/GameQuestionScreen.js